import { useState } from 'react';

import { Switch, Text } from 'shell/components';

const SwitchDemo = () => {
    const [checked, setChecked] = useState(true);

    const handleChange = (event, newCheckedState) => {
        console.log({ event, newCheckedState });
        setChecked(newCheckedState);
    };

    return (
        <>
            <Text variant={'sh1'}>Switch</Text>
            <Switch />
            <Switch checked={checked} onChange={handleChange} />
        </>
    );
};

export default SwitchDemo;
